function generateDefaultInitialHomePageComponentsState() {
  return {
    homePageComponents: null,
    cmsHomePageComponents: null,
    cmsHomePageComponentsWithBannerList: null
  };
}

function homePageComponentsReducer(
  state = generateDefaultInitialHomePageComponentsState(),
  action
) {
  let newState;
  switch (action.type) {
    case 'GET_HOME_PAGE_COMPONENTS_FULFILLED': {
      newState = {
        ...state,
        homePageComponents: action.payload.response.data.data
      };

      break;
    }

    case 'GET_CMS_HOME_PAGE_COMPONENTS_FULFILLED': {
      newState = {
        ...state,
        cmsHomePageComponents: action.payload.response.data.data
      };
      break;
    }

    case 'GET_HOMEPAGE_COMPONENTS_WITH_BANNER_LIST_FULFILLED': {
      const responseData = action.payload.response;

      newState = {
        ...state,
        cmsHomePageComponentsWithBannerList: responseData
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default homePageComponentsReducer;
export {generateDefaultInitialHomePageComponentsState};
